import {trackPageOpen} from './events/navigation'
import measureWebVitals from './events/performance'

measureWebVitals()
trackPageOpen()
